import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funkprotokoll-eintrag-erfassen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollEintragErfassenEffects {

    FunkprotokollEintragErfassen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKPROTOKOLL_EINTRAG_ERFASSEN),
        mergeMap((x: ac.PostFunkprotokollEintragErfassenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunkprotokollEintragErfassen(x.funkprotokollEintragRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunkprotokollEintragErfassenErfolgreichAction(result, x.funkprotokollEintragRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunkprotokollEintragErfassenFehlerAction(error, x.funkprotokollEintragRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollCommandService);
        }
        return this.service;
    }
}
